import _ from 'lodash'
import keyMirror from 'keymirror'

const GLOBAL_MODAL_CONSTANTS = keyMirror({
  MODAL_OPENED: null,
  MODAL_CLOSED: null,
})

export default _.mapValues(GLOBAL_MODAL_CONSTANTS, _.uniqueId)



// WEBPACK FOOTER //
// ./src/scripts/constants/GlobalModalConstants.js